import React from 'react';
import { renderMjml } from '@wix/wix-emails-mjml-render-utils';
import mjmlBrowser from 'mjml-browser';
import { parser } from 'posthtml-parser';
import { type FontFamily } from '@wix/ambassador-emails-email-marketing-v1-font/types';

import { useCampaign } from '../../contexts';

import { AstNode } from './AstNode';

interface MjmlViewerProps {
  experiments: Record<string, string>;
  customFonts?: FontFamily[];
}

export const MjmlViewer = ({ experiments, customFonts }: MjmlViewerProps) => {
  const campaign = useCampaign();

  const html = renderMjml({
    mjml: campaign.data.composerData.mjml,
    preheader: campaign.data.subject,
    t: () => '',
    mjml2html: mjmlBrowser,
    options: { showAd: false },
    customFonts,
    customFontsEnabled:
      experiments['specs.so.public.EnableUploadedFonts'] === 'true',
  });
  const parsedHtmlTree = parser(html, { recognizeSelfClosing: true });

  return (
    <>
      {parsedHtmlTree
        .filter((node) => typeof node !== 'string')
        .map((node) => (
          // key generated randomly, not expecting LP rerenders
          <AstNode node={node} key={`${Math.random()}`} />
        ))}
    </>
  );
};
